var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "inherit",
    strokeWidth: 1,
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 0.156922L0.65 2.65692C0.25 2.75692 0 3.15692 0 3.55692V9.85692C0 13.7569 3.2 17.5569 7.15 19.4569C7.7 19.7069 8.35 19.7069 8.9 19.4569C12.8 17.5569 16 13.7569 16 9.85692V3.55692C16 3.15692 15.75 2.75692 15.35 2.60692L8.7 0.106922C8.25 -0.0430781 7.75 -0.0430781 7.3 0.156922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.5dac14f110d6178b6bdc430f4ebc6bc0.svg";
export { ForwardRef as ReactComponent };